import { Injectable } from '@angular/core';
import { HelpButtonState } from '../models/user';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerSupportService {
  constructor(private userService: UserService) {}

  public openSupport(config?: { showCommand?: string; target?: string; bootObj?: any }): void {
    if (this.customSupportEnabled) {
      window.open(this.customSupportUrl, '_blank');
    } else {
      try {
        if (config?.bootObj) {
          (window as any).Intercom('boot', config.bootObj);
        }
        (window as any).Intercom(config?.showCommand || 'showSpace', config?.target || 'home');
      } catch (error) {
        window.open('https://www.pencilspaces.com/support', '_blank', 'noopener');
      }
    }
  }

  public openLink(url: string = this.customSupportUrl): void {
    window.open(this.customSupportEnabled ? this.customSupportUrl : url, '_blank', 'noopener');
  }

  get customSupportEnabled(): boolean {
    const buttonBehaviour =
      this.userService.user.value?.user.institution?.settings?.helpButtonBehaviour;
    return Boolean(buttonBehaviour?.state === HelpButtonState.CUSTOM && buttonBehaviour?.url);
  }

  get customSupportUrl(): string {
    return this.userService.user.value?.user.institution?.settings?.helpButtonBehaviour
      .url as string;
  }
}
